export default {
  GET_EXCEED_SESSION_PAGE: {
    url: '/exceed-session/page',
    method: 'GET'
  }
};
